import React, { useContext, useEffect, useState } from 'react'
import Wrapper from '../../../../components/common/Wrapper/Wrapper'
import service from '../../../../api/services'
import organisms from '../../../../components/organisms'
import { Default_Page_Limit } from '../../../../constants/defaultValues'
import { useToasts } from 'react-toast-notifications'
import { HeaderHeading } from '../../../../Context'
import molecules from '../../../../components/molecules'
const { Store } = organisms
const Index = () => {
  const { addToast } = useToasts();
  const { setHeader, setSidebar }: any = useContext(HeaderHeading);
  const [initialLoading, setInitialLoading] = useState<boolean>(false)
  const [storeListing, setStoreListing] = useState<any>()
  const [search, setSearch] = useState('');
  const [pageCount, setPageCount] = useState<number>(1);
  const [limit, setLimit] = useState(Default_Page_Limit);
  const [ecomEnabled, setEcomEnabled] = useState<boolean>(false)
  const [storeData, setStoreData] = useState<{ store_id: string, ecom_status: number }>({
    store_id: "",
    ecom_status: 0
  })

  const { ConfirmationModal } = molecules

  const getStoreListing = async () => {
    try {
      const response = await service.store.storeListingService({ search: search, page: pageCount, limit: limit, });
      setStoreListing(response.data)
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    setHeader("Store - Add Store")
    setSidebar(false)
    getStoreListing()
  }, [pageCount])

  useEffect(() => {
    setPageCount(1)
    if (pageCount == 1 && initialLoading) {
      getStoreListing()
    }
    setInitialLoading(true)
  }, [limit, search])

  const handleStatus = async (id: string, status: number) => {
    const payload = {
      "status": status
    }
    try {
      // let response = await service.store.storeStatus(id);
      let response = await service.store.storeStatus(id, payload);
      if (response.status === 200) {
        addToast('Status updated successfully', {
          appearance: 'success',
          autoDismiss: true,
          autoDismissTimeout: 3000,
        });
        getStoreListing()
      }
    } catch (error) {

    }
  }

  // e-commerce status update
  const handleEcomStatusApi = async (store_id: string, ecom_status: number) => {
    try {
      const response = await service.store.ecomStatus(store_id, { ecom_status })
      if (response.status === 200) {
        addToast('E-commerce status updated successfully', {
          appearance: 'success',
          autoDismiss: true,
          autoDismissTimeout: 3000,
        });
        getStoreListing();
        setEcomEnabled(!ecomEnabled)
      }
    } catch (error: any) {
      console.error(error);
      addToast(error?.response?.data?.message, {
        appearance: 'error',
        autoDismiss: true,
        autoDismissTimeout: 3000,
      });
    }
  }
  // end

  //handle the ecom status
  const handleEcomStatus = (ecom_status: number, store_id: string) => {
    setEcomEnabled(!ecomEnabled);
    console.log("ecom_status", ecom_status);
    console.log("store_id", store_id);
    setStoreData({
      store_id: store_id,
      ecom_status: ecom_status
    })
  }
  //end


  return (
    <Wrapper>
      <Store
        limit={limit}
        currentPage={pageCount}
        storeListing={storeListing}
        setSearch={setSearch}
        setLimitPerPage={setLimit}
        setCurrentPage={setPageCount}
        handleStatus={(id: string, status: number) => handleStatus(id, status)}
        handleEcomStatus={(store_id: string, ecom_status: number) => handleEcomStatus(ecom_status, store_id)}
      />
      {ecomEnabled && (
        <ConfirmationModal
          show={ecomEnabled}
          handleConfirmItem={() => handleEcomStatusApi(storeData?.store_id, storeData?.ecom_status)}
          onHide={() => {
            setEcomEnabled(!ecomEnabled);
            setStoreData({
              store_id: "",
              ecom_status: 0
            });
          }}
          message={"change the ecom status of store"}
        />
      )}
    </Wrapper>
  )
}

export default Index